/* istanbul ignore file */
const positiveNumberRegEx = /^((?!^0+$|0+[.]0+$)0|[1-9]\d{0,5})(?:[.]\d{1,2})?$/;

const positiveAmount = {
  value: positiveNumberRegEx,
  message: 'Must be a positive number (max 6 digits and 2 decimals)',
};

export default {
  baseAmountType: {
    type: 'string',
    required: true,
  },
  currency: {
    type: 'string',
    required: true,
  },
  finalAmountGross: {
    type: 'number',
    required: true,
    minValue: { value: '$probationAmountGross' },
    regex: positiveAmount,
  },
  probationAmountGross: {
    type: 'number',
    required: true,
    maxValue: {
      value: '$finalAmountGross',
      message: "Probation period value can't be greater than base amount value",
    },
    regex: positiveAmount,
  },
  probationPeriodReduction: {
    type: 'number',
    required: false,
  },
  office: {
    type: 'string',
    required: true,
  },
  contractType: {
    type: 'string',
    required: true,
  },
  positionFillRequest: {
    type: 'string',
    required: true,
  },
};
